import ApiCaller from 'lib/ApiCaller';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store/store';
import { APP_STATUS } from 'types/app';
import SystemSettingsApi from 'api/SystemSettingsApi';
import {
  setNcapEnabled,
  setSystemSettingsStatus,
} from 'store/actions/systemSettings/actions';

const useSystemSettings = () => {
  const loggedUser = useSelector((state: AppState) => state.session.userInfo);
  const { ncapEnabled, status } = useSelector(
    (state: AppState) => state.systemSettings,
  );
  const [refresh, setRefresh] = useState(0);
  const dispatch = useDispatch();

  const refetchSettings = () => setRefresh((prev) => prev + 1);

  const fetchNcapStatus = async () => {
    if (!loggedUser?.token) return;

    try {
      dispatch(setSystemSettingsStatus(APP_STATUS.LOADING));
      const settingsApi = new SystemSettingsApi(new ApiCaller(loggedUser.token));
      const result = await settingsApi.getNcapStatus();
      dispatch(setNcapEnabled(result.enabled));
      dispatch(setSystemSettingsStatus(APP_STATUS.IDLE));
    } catch (error) {
      console.error('Error fetching NCAP status:', error);
      dispatch(setSystemSettingsStatus(APP_STATUS.FAILED));
    }
  };

  const updateNcapEnabled = async (enabled: boolean): Promise<boolean> => {
    if (!loggedUser?.token) return false;

    try {
      const settingsApi = new SystemSettingsApi(new ApiCaller(loggedUser.token));
      await settingsApi.updateSetting(
        'NCAP_INTEGRATION_ENABLED',
        enabled,
      );
      dispatch(setNcapEnabled(enabled));
      return true;
    } catch (error) {
      console.error('Error updating NCAP status:', error);
      return false;
    }
  };

  useEffect(() => {
    if (loggedUser?.token && status === APP_STATUS.IDLE) {
      fetchNcapStatus();
    }
  }, [loggedUser?.token]);

  useEffect(() => {
    if (refresh !== 0) {
      fetchNcapStatus();
    }
  }, [refresh]);

  return {
    ncapEnabled,
    status,
    refetchSettings,
    updateNcapEnabled,
  };
};

export default useSystemSettings;

